import { FeatureKeys } from '../../../redux/features/app/AppState';

export const UserProfile = ({ activeUserInfo, features }) => {
    const isSimplifiedExperience = features[FeatureKeys.SimplifiedExperience].enabled;

    return (
        <div className="flex items-center [&>span]:mr-4 [&>span>span]:mt-[6px] [&>span>span]:ml-2 [&>span>span]:rounded-full [&>span>span]:text-black [&>span>span]:font-bold [&>span>span]:text-sm [&>span>span]:bg-teal-400">
            {/* Avatar */}
            <div className="w-10 h-10 bg-teal-400 rounded-full flex items-center justify-center text-black font-bold">
                {/* Example: First letter of username */}
                {activeUserInfo?.username?.charAt(0).toUpperCase()}
            </div>

            {/* User Info */}
            <div className="ml-4">
                <div className="text-sm font-bold text-black dark:text-white">{activeUserInfo?.username}</div>
                <div className="text-sm text-gray-600 dark:text-white">{activeUserInfo?.email}</div>
            </div>

            {/* Presence Indicator */}
            {!isSimplifiedExperience && <div className="ml-2 w-3 h-3 bg-green-500 rounded-full"></div>}
        </div>
    );
};
